import {Modal} from '@/components-v2/organisms'
import {useSelectionModalContent} from '@/containers/Promotions/components/SelectionModalContent/selectionModalContent-hook'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {BuyType} from '@/utils/constants/promotionConstants'
import {useEffect, useMemo} from 'react'
import SelectionModalContentV2 from './SelectionModalContent/SelectionModalContentV2'

const PromotionSelectionModalV2 = ({show, type, onClose, onSubmit, conditionValues, isExclude = false}) => {
  const isProductIdList = type === BuyType.PRODUCT_ID
  const modalKey = useMemo(() => {
    return `${type}-${conditionValues?.itemType || ''}-${conditionValues?.values?.length || 0}-${conditionValues?.productCombination || false}`
  }, [type, conditionValues])

  const selectionModalHookValue = useSelectionModalContent(type, conditionValues)
  const {combination, selectedTags, isPrimaryButtonDisabled} = selectionModalHookValue

  useEffect(() => {
    if (!show) return

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [show])

  const getModalTitle = () => {
    switch (type) {
      case BuyType.CATEGORY:
        return 'Category / Sub Category'
      case BuyType.BRAND:
        return 'Brands / Sub Brands'
      case BuyType.PRODUCT:
        return 'Products'
      case BuyType.PRODUCT_ID:
        return 'Product ID List'
      case BuyType.GTINS:
        return 'GTIN List'
      case BuyType.COMBO_ID:
        return 'Combo ID List'
      default:
        return ''
    }
  }

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(selectedTags, combination)
    }
  }

  const getModalDescription = () => {
    if (isExclude) {
      return 'What do you want to exclude from this deal?'
    }
    switch (type) {
      case BuyType.CATEGORY:
      case BuyType.BRAND:
      case BuyType.PRODUCT:
        return 'What do you want this deal to apply to?'
      case BuyType.PRODUCT_ID:
      case BuyType.GTINS:
      case BuyType.COMBO_ID:
      default:
        return ''
    }
  }

  return (
    <Modal
      key={modalKey}
      showModal={show}
      onCloseModal={onClose}
      hideCloseButton
      closeOnOutsideClick={false}
      title={getModalTitle()}
      text={getModalDescription()}
      showSlot
      showPrimaryButton
      primaryButtonProps={{text: 'Apply', onClick: handleSubmit, disabled: isPrimaryButtonDisabled}}
      showTertiaryButton
      tertiaryButtonProps={{text: 'Cancel', onClick: onClose}}
      className={isProductIdList ? 'product-id-selection-modal' : ''}
      type={
        isProductIdList
          ? 'XL'
          : [BuyType.CATEGORY, BuyType.BRAND, BuyType.PRODUCT].includes(type)
            ? MODAL_TYPE.SMALL
            : MODAL_TYPE.FLUID
      }
    >
      <SelectionModalContentV2 type={type} selectionModalHookValue={selectionModalHookValue} isExclude={isExclude} />
    </Modal>
  )
}

export default PromotionSelectionModalV2
